import {
  PAYMENT_V3_GET_DETAILS_SUCCESS,
  USER_LOGOUT_SUCCESS,
} from "data/constants"

const defaultState = {
  paymentDetailsV3: null,
}

function profileFinancialDetailsStore(state = defaultState, action) {
  switch (action.type) {
    case PAYMENT_V3_GET_DETAILS_SUCCESS:
      return {
        ...state,
        paymentDetailsV3: action.data,
      }
    case USER_LOGOUT_SUCCESS:
      return defaultState
    default:
      return state
  }
}

export default profileFinancialDetailsStore
